import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';

import { downloadAddSoftList } from '../../actions/downloadTask';
import { logging, logPostInfo } from '../../actions/log';
import { getLocalSoft, setUpdateNotifyStatus } from '../../actions/native';
import { downloadAddSoft } from '../../actions/downloadTask';
import CommReco from '../../components/CommReco/CommReco';
import LineCardDReco from '../../components/LineCardDReco/LineCardDReco';
import LineCardUpdate from '../../components/LineCardUpdate/LineCardUpdate';
import Loading from '../../components/Loading/Loading';
import { CONTEXT } from '../../config';
import Banner from '../../static/update_none.png';
import { getQueryString, logNative } from '../../utils/utils';
import styles from './Update.module.less';
import { PCStoreJsBridge } from '../../nativeapi';
import Ignore from './Ignore';
import Toast from '../../components/Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectDownloadSofts = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.softs,
);

const selectSearchRecommend = createSelector(
  state => state.search,
  search => search.searchRecommend,
);

const selectIsEnabledSilent = createSelector(
  state => state.layout,
  layout => layout.isEnabledSilent,
);

const selectNative = createSelector(
  state => state.native,
  native => native,
);
function Update() {
  const [upgradeSoftsData, setUpgradeSoftsData] = useState(null);
  const [ignoreSoftsData, setIgnoreSoftsData] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const downloadSofts = useSelector(selectDownloadSofts); // 正在下载
  const logInfoData = useSelector(selectLogInfo);
  const instRecommend = useSelector(selectSearchRecommend); // 点击更新后的推荐

  const isEnabledSilent = useSelector(selectIsEnabledSilent); // 是否打开快速静默安装
  const {
    supportSilentInstSoft: silentInstSoft,
    updateNotifyStatus,
    upgradeSoftsAll: allUpgradeSoftsData,
    installedSoft,
  } = useSelector(selectNative); // 支持快速静默安装的应用列表 // 升级弹窗开关状态

  const [checkedInfo, setCheckedInfo] = useState({});
  const [checkedAll, setCheckedAll] = useState(true);
  const [checkedLength, setCheckedLength] = useState(0);
  const [ignoreVisible, setIgnoreVisible] = useState(false);
  const [collapaseUpdate, setCollapaseUpdate] = useState(true);
  const [initTime, setInitTime] = useState(+new Date());
  const [loading, setLoading] = useState(true);
  const [node, setNode] = useState(null);

  useEffect(() => {
    if (allUpgradeSoftsData && allUpgradeSoftsData.length > 0) {
      setLoading(false);
    } else {
      const timer = setTimeout(() => {
        setLoading(false);
        clearTimeout(timer);
      }, 2500);
    }
  }, [allUpgradeSoftsData]);
  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Update`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  // 获取全部待升级软件，蒋软件拆分成待升级、忽略升级列表
  useEffect(() => {
    const updateList = [];
    const ignoreList = [];

    if (allUpgradeSoftsData && allUpgradeSoftsData.length > 0) {
      allUpgradeSoftsData.forEach(item => {
        if (item.permanentIgnore) {
          ignoreList.push(item);
        } else {
          const ignoreCurVersion = item.bIgnore && item.ignoredVersion === item.version; // 是否忽略当前升级版本
          // eslint-disable-next-line no-unused-expressions
          ignoreCurVersion ? ignoreList.push(item) : updateList.push(item);
        }
      });
    }
    setUpgradeSoftsData(updateList);
    setIgnoreSoftsData(ignoreList);
  }, [allUpgradeSoftsData]);

  const getCheckSoft = useCallback((checked_info, upgrade_softs) => {
    const checkedArr = upgrade_softs.filter(soft => checked_info[soft.softID] === true);
    return checkedArr;
  });

  const handleShowOther = useCallback(() => {
    // 点击随便逛逛
    dispatch(
      logging({
        category: 'C',
        action: 'Update_SeeOther',
        label: '',
        param2: {
          source: 'Update',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [logInfoData]);

  const handleOneCheckbox = useCallback(
    (softID, checked) => {
      checkedInfo[softID] = checked;
      const checkedArr = getCheckSoft(checkedInfo, upgradeSoftsData);
      if (checkedArr.length === upgradeSoftsData.length) {
        setCheckedAll(true);
      } else if (checkedAll) {
        setCheckedAll(!checkedAll);
      }
      setCheckedInfo(checkedInfo);
      setCheckedLength(checkedArr.length);
    },
    [checkedInfo, upgradeSoftsData],
  );

  const handleAllCheck = useCallback(() => {
    upgradeSoftsData.forEach(soft => {
      checkedInfo[soft.softID] = !checkedAll;
    });
    const checkedArr = getCheckSoft(checkedInfo, upgradeSoftsData);

    setCheckedAll(!checkedAll);
    setCheckedInfo(checkedInfo);
    setCheckedLength(!checkedAll ? checkedArr.length : 0);
  }, [checkedInfo, upgradeSoftsData, checkedAll]);

  /**
   * 点击全部下载
   */
  const handleAllUpdate = useCallback(() => {
    const checkedArr = getCheckSoft(checkedInfo, upgradeSoftsData);
    const softIDs = [];
    checkedArr.forEach(
      softItem => {
        // 将没有在下载任务里面的和下载失败的继续添加下载
        const found =
          downloadSofts &&
          downloadSofts.find(
            soft_ =>
              (soft_.type === 'pc' &&
                soft_.pc.SoftID === (softItem.SoftID || softItem.softID) &&
                soft_.attr.act !== 'cancel') ||
              (soft_.type === 'apk' &&
                soft_.apk.pkg === softItem.packageName &&
                soft_.attr.act !== 'cancel'),
          );
        if (found) {
          return;
        }

        softIDs.push(
          softItem.androidType === '1' ? softItem.packageName : softItem.softID || softItem.SoftID,
        );

        const newSoftItem = { ...softItem };
        newSoftItem.logInfo = {
          source: 'Update',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: softItem.androidType === '1' ? softItem.packageName : softItem.softID,
          softName: softItem.softName,
          softType: softItem.androidType === '1' ? '1' : '0',
          type: 'u',
          url: softItem.downLoadUrl,
        };

        if (newSoftItem.androidType === '1') {
          dispatch(downloadAddSoft({ ...newSoftItem, isClick: 'click_update_all' }));
        } else {
          const installparams = {};
          if (silentInstSoft && silentInstSoft.length > 0 && isEnabledSilent) {
            const silentSoft = silentInstSoft.find(soft_ => soft_.softID === newSoftItem.softID);
            if (silentSoft && silentSoft.softID) {
              newSoftItem.logInfo.type = 'xu';
              if (silentSoft.silentParamDic) {
                installparams.quiet = silentSoft.silentParamDic;
              }
              if (silentSoft.silentDirParamDic) {
                installparams.todir = silentSoft.silentDirParamDic;
              }
            }
          }
          dispatch(downloadAddSoft({ ...newSoftItem, installparams, isClick: 'click_update_all' }));
        }
      },
      [checkedInfo, upgradeSoftsData, silentInstSoft, isEnabledSilent],
    );

    if (softIDs.length > 0) {
      // 更新页面 点击全部升级 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Upgrade_All',
          label: '',
          param2: {
            source: 'Update',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softids: softIDs.join(', '), // 选中/取消选中
            ckall: checkedAll ? 0 : 1,
          },
        }),
      );
    }
  }, [dispatch, logInfoData, downloadSofts, checkedAll, checkedInfo, upgradeSoftsData]);

  useEffect(() => {
    if (upgradeSoftsData && upgradeSoftsData.length > 0) {
      const checkedInfoObj = {};
      const softIDs = [];
      upgradeSoftsData.forEach(soft => {
        checkedInfoObj[soft.softID] = true;
        softIDs.push(soft.softID || soft.SoftID);
      });
      setCheckedInfo(checkedInfoObj);
      setCheckedLength(upgradeSoftsData.length);
    }
  }, [upgradeSoftsData]);

  // 更新传入的软件
  useEffect(() => {
    const softIdStr = getQueryString('softIds', location.search) || '';
    const pnsStr = getQueryString('pns', location.search) || '';
    const sdkExt = getQueryString('sdkExt', location.search) || '';
    const bizId = getQueryString('bizId', location.search) || '';
    const bizType = getQueryString('bizType', location.search) || '';
    const softIds = softIdStr.split(',');
    const pns = pnsStr.split(',');
    const upgradeIsDownload = sessionStorage.getItem('upgradeIsDownload'); // 拒绝重复下载
    if (
      installedSoft &&
      installedSoft.length > 0 &&
      upgradeSoftsData &&
      upgradeSoftsData.length > 0 &&
      silentInstSoft &&
      silentInstSoft.length >= 0 &&
      (!upgradeIsDownload || upgradeIsDownload !== `${softIdStr}&${pnsStr}`)
    ) {
      let bizInfo = {};
      if (bizId && bizType) {
        bizInfo = JSON.stringify({ bizId, bizType, sdkExt });
      }
      if ((softIds && softIds.length > 0) || (pns && pns.length > 0)) {
        const androidSoftList = [];
        const pcSoftList = [];
        upgradeSoftsData.forEach(softItem => {
          const logInfo = {
            source: 'Update',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: softItem.androidType === '1' ? softItem.packageName : softItem.softID,
            softName: softItem.softName,
            softType: softItem.androidType === '1' ? '1' : '0',
            type: 'u',
            url: softItem.downLoadUrl,
          };
          if (softItem.androidType !== '1' && softIds && softIds.length > 0) {
            softIds.forEach(softId => {
              if (softItem.softID === softId) {
                const installparams = {};
                if (silentInstSoft && silentInstSoft.length > 0 && isEnabledSilent) {
                  const silentSoft = silentInstSoft.find(soft_ => soft_.softID === softItem.softID);
                  if (silentSoft && silentSoft.softID) {
                    logInfo.type = 'xu';
                    if (silentSoft.silentParamDic) {
                      installparams.quiet = silentSoft.silentParamDic;
                    }
                    if (silentSoft.silentDirParamDic) {
                      installparams.todir = silentSoft.silentDirParamDic;
                    }
                  }
                }
                pcSoftList.push({ ...softItem, logInfo, installparams, bizInfo });
              }
            });
          }
          if (softItem.androidType === '1' && pns && pns.length > 0) {
            pns.forEach(pn => {
              if (softItem.packageName === pn) {
                androidSoftList.push({ ...softItem, logInfo, bizInfo });
              }
            });
          }
        });
        if (androidSoftList.length > 0 || pcSoftList.length > 0) {
          dispatch(downloadAddSoftList([...androidSoftList, ...pcSoftList]));
        }
        // 当命令行只有一个软件, 且不再更新列表中时
        // 当更新列表找不到传入的软件时
        if ([...androidSoftList, ...pcSoftList].length === 0) {
          let allSoftIds = [...softIds, ...pns].filter(item => {
            return item !== '' && item !== ' ';
          });
          if (allSoftIds.length === 1) {
            const found = installedSoft.find(soft => {
              return (soft.SoftID || soft.softID || soft.softId) === allSoftIds[0];
            });
            if (found) {
              Toast.success({
                content: `${found.displayName}已经是最新版本!`,
              });
            } else {
              Toast.success({
                content: '该软件已经是最新版本!',
              });
            }
          }
        }

        sessionStorage.setItem('upgradeIsDownload', `${softIdStr}&${pnsStr}`);
        setTimeout(() => {
          sessionStorage.setItem('upgradeIsDownload', ``);
        }, 10000);
        // 添加任务成功后，重新进入此页面，洗掉url上面的参数，用于控制更新应用完成之后，弹出'该软件已经是最新版本!'toast提示
        history.replace(`${CONTEXT}/update`);
      }
    }
  }, [dispatch, upgradeSoftsData, logInfoData, location.search]);

  useEffect(() => {
    dispatch(getLocalSoft());
  }, [dispatch]);

  useEffect(() => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Update',
        label: '',
        param2: {
          source: 'Update',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Update',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);
  const getUpdateNotifyStatus = () => {
    PCStoreJsBridge.getAppStoreSwitch({
      type: 1,
      //   UNKNOWN = 0,
      //   SWITCH_UPGRADE_POPUP = 1, // 升级弹窗开关
      //   SWITCH_RIGHT_MENU = 2,// 右键菜单开关
    }).then(({ succ, enable }) => {
      if (succ) {
        dispatch(setUpdateNotifyStatus(enable));
      }
    });
  };
  useEffect(getUpdateNotifyStatus, []);
  const handleUpdateNotifyStatus = () => {
    PCStoreJsBridge.setAppStoreSwitch({
      type: 1,
      enable: true,
      source: 1 /* 1：设置中心勾选框创建；2：关闭商店时创建；3：创建商店时创建  */,
    }).then(
      () => {
        getUpdateNotifyStatus();
        Toast.success({
          content: '设置成功！',
        });
      },
      () => {
        Toast.error({
          content: '设置失败！',
        });
      },
    );

    // 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Upgrade_Open',
        label: '',
        param2: {
          source: 'Update',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  };
  const handleCollapse = () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Update_List_Open',
        label: '',
        param2: {
          source: 'Update',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: !collapaseUpdate ? 'off' : 'on',
        },
      }),
    );
    if (!collapaseUpdate && node) {
      node.scrollTop = 0;
    }
    setCollapaseUpdate(!collapaseUpdate);
  };

  const handleIgnoreList = type => () => {
    setIgnoreVisible(type);
    if (type) {
      // 打开忽略列表弹窗
      dispatch(
        logging({
          category: 'C',
          action: 'Update_Ignored',
          label: '',
          param2: {
            source: 'Update',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
  };

  const changView = content => {
    dispatch(
      logging({
        category: 'I',
        action: 'Update_Content_Show',
        label: '',
        param2: {
          source: 'Update',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          ...content,
        },
      }),
    );
  };

  if (allUpgradeSoftsData === null && loading) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.page} ref={r => setNode(r)} pagescroll="PCStore_Page_Scroll">
      <div className={styles.page_container}>
        {/* loading */}
        {upgradeSoftsData && upgradeSoftsData.length > 0 && (
          <div className={styles.updating}>
            <div className={styles.updating_header}>
              <div className={styles.header_left}>
                <div className={styles.header_left_label} onClick={handleAllCheck}>
                  {checkedAll ? (
                    <div className={styles.nopopChange} />
                  ) : (
                    <div className={styles.nopop} />
                  )}
                  <span>全选</span>
                </div>
                <div className={styles.header_left_info}>
                  共有
                  <span className={styles.header_left_info_num}> {upgradeSoftsData.length} </span>
                  款软件可以升级
                </div>
              </div>
              {ignoreSoftsData && ignoreSoftsData.length > 0 && (
                <div className={styles.header_ignore} onClick={handleIgnoreList(true)}>
                  已忽略软件({ignoreSoftsData.length})
                </div>
              )}
              <div
                className={checkedLength === 0 ? styles.header_btn_disable : styles.header_btn}
                onClick={() => {
                  if (checkedLength !== 0) handleAllUpdate();
                }}
              >
                全部升级
              </div>
            </div>
            <div className={styles.updating_list}>
              {(collapaseUpdate ? upgradeSoftsData.slice(0, 3) : upgradeSoftsData).map((soft, i) =>
                soft.androidType === '1' ? (
                  <React.Fragment key={i}>
                    <LineCardUpdate
                      soft={soft}
                      logInfo={{ action: 'Upgrade_Single', source: 'Update' }}
                      checkedInfo={checkedInfo}
                      changeCheckbox={handleOneCheckbox}
                      key={i}
                    />
                    {instRecommend[soft.packageName] &&
                      instRecommend[soft.packageName].apps &&
                      instRecommend[soft.packageName].apps.length > 4 && (
                        <LineCardDReco
                          recommendData={instRecommend[soft.packageName]}
                          info={{ isHiddleName: true }}
                          logInfo={{
                            source: `Upgrade_Single|| ||DReco||${soft.packageName}`,
                            source_p: logInfoData.source_p,
                            source_pp: logInfoData.source_pp,
                          }}
                        />
                      )}
                  </React.Fragment>
                ) : (
                  <React.Fragment key={i}>
                    <LineCardUpdate
                      soft={soft}
                      logInfo={{ action: 'Upgrade_Single', source: 'Update' }}
                      checkedInfo={checkedInfo}
                      changeCheckbox={handleOneCheckbox}
                    />
                    {instRecommend[soft.softID] &&
                      instRecommend[soft.softID].apps &&
                      instRecommend[soft.softID].apps.length > 4 && (
                        <LineCardDReco
                          recommendData={instRecommend[soft.softID]}
                          info={{ isHiddleName: true }}
                          logInfo={{
                            source: `Upgrade_Single|| ||DReco||${soft.softID}`,
                            source_p: logInfoData.source_p,
                            source_pp: logInfoData.source_pp,
                          }}
                        />
                      )}
                  </React.Fragment>
                ),
              )}
            </div>
            {upgradeSoftsData && upgradeSoftsData.length > 3 && (
              <div className={styles.updating_collapse} onClick={handleCollapse}>
                {collapaseUpdate ? (
                  <div className={styles.updating_collapse_text}>
                    展开全部软件
                    <i
                      className={classNames(
                        'iconfont icon-arrow_down_small',
                        styles.updating_collapse_icon,
                      )}
                    />
                  </div>
                ) : (
                  <div className={styles.updating_collapse_text}>
                    收起全部软件
                    <i
                      className={classNames(
                        'iconfont icon-arrow_up_small',
                        styles.updating_collapse_icon,
                      )}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        {upgradeSoftsData && upgradeSoftsData.length === 0 && (
          <div className={styles.updated}>
            {ignoreSoftsData && ignoreSoftsData.length > 0 && (
              <div
                className={classNames(styles.header_ignore, styles.header_ignore_nodata)}
                onClick={handleIgnoreList(true)}
              >
                已忽略软件({ignoreSoftsData.length})
              </div>
            )}
            <div className={styles.updated_banner}>
              <img className={styles.updated_banner_img} src={Banner} alt="" />
              <div className={styles.updated_banner_desc}>
                暂无可更新软件
                <Link
                  className={styles.updated_banner_desc_link}
                  to={{ pathname: `${CONTEXT}/` }}
                  onClick={handleShowOther}
                >
                  随便逛逛
                </Link>
              </div>
            </div>
          </div>
        )}
        {upgradeSoftsData !== null && !updateNotifyStatus && (
          <div
            className={classNames(
              styles.updateNotify,
              upgradeSoftsData && upgradeSoftsData.length === 0
                ? styles.updateNotify_transup
                : styles.updateNotify_transdown,
            )}
          >
            您尚未开启更新提醒，建议您
            <span onClick={handleUpdateNotifyStatus} className={styles.updateNotify_btn}>
              &nbsp;立即开启&nbsp; &gt;
            </span>
          </div>
        )}
        {ignoreSoftsData && ignoreVisible && (
          <Ignore
            handleClose={() => {
              setIgnoreVisible(false);
            }}
            data={ignoreSoftsData}
          />
        )}
        <CommReco logInfo={{ tag: 'Update', hotSall: true, changView }} />
      </div>
    </div>
  );
}

export default () => {
  return (
    <KeepAlive name="update">
      <Update />
    </KeepAlive>
  );
};
